var _style, _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.1 68.1",
    style: {
      enableBackground: "new 0 0 109.1 68.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:#9BA9B7;}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{fill:url(#SVGID_7_);}\r\n\t.st8{fill:url(#SVGID_8_);}\r\n\t.st9{fill:url(#SVGID_9_);}\r\n\t.st10{fill:url(#SVGID_10_);}\r\n\t.st11{fill:url(#SVGID_11_);}\r\n\t.st12{fill:url(#SVGID_12_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.8357,
    y1: 53.8788,
    x2: 108.9,
    y2: 53.8788,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00DCAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9FFED"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.8,4.1L25.8,4.1c0-1.6,1.3-2.7,2.7-2.7h77.6c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H28.6 C27.1,6.9,25.8,5.7,25.8,4.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -381.1657,
    y1: 449.8186,
    x2: -381.1657,
    y2: 427.5985,
    gradientTransform: "matrix(0 1 1 0 -419.0648 385.2869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.4,4.1L7.4,4.1c0-1.6,1.3-2.7,2.7-2.7H18c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7h-7.8 C8.7,6.9,7.4,5.7,7.4,4.1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.7,6.5H1.3V4c0-0.2,0-0.4,0-0.6L1.2,3.5c0,0-0.2,0.2-0.6,0.5L0.4,3.7L1.3,3h0.3L1.7,6.5L1.7,6.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.6073,
    y1: 41.8872,
    x2: 108.9,
    y2: 41.8872,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00DCAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9FFED"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.6,16.1L38.6,16.1c0-1.6,1.3-2.7,2.7-2.7h64.8c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H41.4 C39.9,18.9,38.6,17.7,38.6,16.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -369.174,
    y1: 472.0664,
    x2: -369.174,
    y2: 428.6341,
    gradientTransform: "matrix(0 1 1 0 -419.0648 385.2869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.4,16.1L7.4,16.1c0-1.6,1.3-2.7,2.7-2.7h20.7c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H10.2 C8.7,18.9,7.4,17.7,7.4,16.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.4,18.4H0.2v-0.3l0.9-0.9c0.3-0.3,0.5-0.5,0.6-0.6c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2,0.1-0.2,0.1-0.4 s-0.1-0.3-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.3l-0.2-0.3c0.3-0.3,0.7-0.4,1.1-0.4 c0.3,0,0.6,0.1,0.8,0.3s0.3,0.4,0.3,0.7c0,0.2-0.1,0.5-0.2,0.7c-0.1,0.2-0.4,0.5-0.7,0.8L0.7,18l0,0h1.8V18.4z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.4764,
    y1: 29.7031,
    x2: 108.9935,
    y2: 29.7031,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00DCAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9FFED"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.5,28.3L51.5,28.3c0-1.6,1.3-2.7,2.7-2.7h52c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7h-52 C52.6,31,51.5,29.9,51.5,28.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -356.99,
    y1: 494.3144,
    x2: -356.99,
    y2: 429.6696,
    gradientTransform: "matrix(0 1 1 0 -419.0648 385.2869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M7.4,28.3L7.4,28.3c0-1.6,1.3-2.7,2.7-2.7h33.5c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H10.2 C8.7,31,7.4,29.9,7.4,28.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.3,27.9c0,0.2-0.1,0.4-0.2,0.6c-0.2,0.1-0.3,0.2-0.6,0.2l0,0c0.3,0,0.5,0.1,0.6,0.3 c0.1,0.2,0.3,0.4,0.3,0.6c0,0.3-0.1,0.6-0.4,0.8c-0.2,0.2-0.6,0.3-1,0.3c-0.2,0-0.4,0-0.5,0c-0.2,0-0.3-0.1-0.5-0.1v-0.4 c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0,0.3,0.1,0.5,0.1c0.6,0,0.9-0.2,0.9-0.7c0-0.4-0.3-0.6-1-0.6H0.7v-0.3h0.4c0.3,0,0.5-0.1,0.7-0.2 c0.2-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0.1-0.4-0.3-0.5-0.2l-0.2-0.3 c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.1,0.6-0.1c0.3,0,0.6,0.1,0.8,0.2C2.2,27.4,2.3,27.6,2.3,27.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.1728,
    y1: 17.5165,
    x2: 108.9095,
    y2: 17.5165,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00DCAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9FFED"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.2,40.5L32.2,40.5c0-1.6,1.3-2.7,2.7-2.7h71.2c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H34.9 C33.4,43.2,32.2,42,32.2,40.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -344.8034,
    y1: 460.9424,
    x2: -344.8034,
    y2: 428.1163,
    gradientTransform: "matrix(0 1 1 0 -419.0648 385.2869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.4,40.5L7.4,40.5c0-1.6,1.3-2.7,2.7-2.7h14.3c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H10.2 C8.7,43.2,7.4,42,7.4,40.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.6,41.9H2v0.8H1.7v-0.8H0v-0.4l1.7-2.3H2v2.3h0.5L2.6,41.9L2.6,41.9z M1.7,41.6v-1.2c0-0.2,0-0.5,0-0.8 l0,0c-0.1,0.2-0.2,0.3-0.2,0.4l-1.1,1.6H1.7z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.6826,
    y1: 5.3298,
    x2: 108.9798,
    y2: 5.3298,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00DCAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9FFED"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M70.7,52.7L70.7,52.7c0-1.6,1.3-2.7,2.7-2.7h32.8c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H73.4 C71.9,55.4,70.7,54.1,70.7,52.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -332.6167,
    y1: 527.6862,
    x2: -332.6167,
    y2: 431.223,
    gradientTransform: "matrix(0 1 1 0 -419.0648 385.2869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M7.4,52.7L7.4,52.7c0-1.6,1.3-2.7,2.7-2.7h52.7c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H10.2 C8.7,55.4,7.4,54.1,7.4,52.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.3,52.8c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.4,0.3,0.8c0,0.4-0.1,0.7-0.4,0.9c-0.2,0.2-0.6,0.3-1,0.3 c-0.4,0-0.7-0.1-0.9-0.2v-0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0,0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.7-0.2s0.2-0.3,0.2-0.6 c0-0.5-0.3-0.7-0.9-0.7c-0.2,0-0.4,0-0.6,0.1l-0.2-0.3l0.2-1.7h1.8v0.4H0.8l-0.1,1.1C0.9,52.8,1.1,52.8,1.3,52.8z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.6826,
    y1: -4.6702,
    x2: 108.9798,
    y2: -4.6702,
    gradientTransform: "matrix(1 0 0 -1 0 58)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00DCAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A9FFED"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M70.7,62.7L70.7,62.7c0-1.6,1.3-2.7,2.7-2.7h32.8c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H73.4 C71.9,65.4,70.7,64.1,70.7,62.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -322.6167,
    y1: 527.6862,
    x2: -322.6167,
    y2: 431.223,
    gradientTransform: "matrix(0 1 1 0 -419.0648 385.2869)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M7.4,62.7L7.4,62.7c0-1.6,1.3-2.7,2.7-2.7h52.7c1.6,0,2.7,1.3,2.7,2.7l0,0c0,1.6-1.3,2.7-2.7,2.7H10.2 C8.7,65.4,7.4,64.1,7.4,62.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.5,61.8c-0.1,0-0.2,0-0.4,0c-0.8,0.1-1.3,0.7-1.4,1.4h0c0.2-0.2,0.5-0.4,0.9-0.4c0.7,0,1.2,0.5,1.2,1.3 c0,0.7-0.5,1.4-1.3,1.4c-0.8,0-1.4-0.6-1.4-1.7c0-0.8,0.3-1.4,0.7-1.8c0.3-0.3,0.8-0.5,1.2-0.6c0.2,0,0.3,0,0.4,0V61.8z  M2.3,64.1c0-0.6-0.3-0.9-0.8-0.9c-0.3,0-0.6,0.2-0.8,0.5c0,0.1-0.1,0.1-0.1,0.2C0.7,64.5,1,65,1.6,65C2,65,2.3,64.6,2.3,64.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2);
export default __webpack_public_path__ + "static/media/chart2.bdc1a2281e8845608ecc63c4e3be4356.svg";
export { ForwardRef as ReactComponent };